export default defineNuxtPlugin(() => {
  if (import.meta.client) {
    onNuxtReady(() => {
      const router = useRouter()
      router.beforeEach((to, from, next) => {
        if (to.path.startsWith('/preview')) {
          console.log('Reassigning preview page', to, from)
          window.location.assign(to.fullPath)
        }
        next()
      })
    })
  }
})
